import React from 'react';
import './About.css';

const About = ({ data }) => {
    return (
        <section className="about section" id={data.id}>
            <div className="container">
                <div className="section-title">
                    <h2>{data.title}</h2>
                </div>

                <div className="about-content">
                    <div className="about-image">
                        <img src={data.image.src} alt={data.image.alt} />
                        <div className="about-image-overlay"></div>
                    </div>

                    <div className="about-text">
                        {data.paragraphs.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                        <a href="/about-us" className="btn btn-primary about-btn">
                            <i className="fas fa-arrow-right"></i> Learn More About Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
